<template>
  <div class="min-h-screen bg-gray-50">
    <HeaderDefault />

    <!-- Hero Section -->
    <section class="bg-gradient-to-b from-primary to-primary/70 py-16">
      <div class="max-w-screen-xl mx-auto px-4">
        <div class="text-center max-w-3xl mx-auto">
          <h1 class="text-4xl md:text-5xl font-bold text-white mb-4">
            Academic Community Directory
          </h1>
          <p class="text-primary-light text-lg">
            Connect with academic professionals, researchers, and experts
          </p>
        </div>
      </div>
    </section>

    <!-- Directory Section -->
    <section class="py-12">
      <div class="max-w-screen-xl mx-auto px-4">
        <!-- Alphabet Navigation -->
        <div class="flex flex-wrap justify-center gap-2 mb-12">
          <nuxt-link
            v-for="letter in lowercaseAlphabets"
            :key="letter"
            :to="'/people/' + letter"
            class="w-10 h-10 flex items-center justify-center rounded-lg font-medium transition-all uppercase"
            :class="
              route.params.id === letter
                ? 'bg-primary text-white shadow-lg scale-110'
                : 'bg-primary/10 text-primary hover:bg-primary/20'
            "
          >
            {{ letter }}
          </nuxt-link>
        </div>

        <!-- Members Grid -->
        <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
    
          <nuxt-link
            v-for="speaker in speakers.data"
            :key="speaker.id"
            :to="`/profile/${speaker.id}`"
            class="block transition-transform hover:scale-[1.02] duration-300"
          >
            <ProfileCard
              :profile="speaker.attributes"
            />
          </nuxt-link>

        </div>
      </div>
    </section>

    <FooterDefault />
  </div>
</template>

<script setup lang="ts">
const route = useRoute();

const lowercaseAlphabets = Array.from({ length: 26 }, (_, i) =>
  String.fromCharCode(97 + i)
);

const { find } = useStrapi()

const { data: speakers } = await useAsyncData("speakers", () =>
  find(
    "aa-users",
    {
      pagination: {
        pageSize: 350,
      },
      sort: "first_name:asc",
    }
  )
);

useHead({
  title: "Academic Directory - Find and Connect with Scholars",
  meta: [
    {
      name: "description",
      content:
        "Browse our directory of academic professionals, researchers, and experts.",
    },
  ],
});
</script>
